import React from 'react'
import { Form } from 'reactstrap'
import PropTypes from 'prop-types'

const DeviseLayout = ({
  children,
  id = null,
  onSubmit = null,
  title
}) => (
  <div className="d-flex justify-content-center align-items-center min-vh-100">
    <div
      className="p-4 p-md-5"
      style={{ width: '100%', maxWidth: '400px' }}
    >
      <h2 className="text-center mb-4">{title}</h2>
      {onSubmit === null ? (
        <div id={id}>
          {children}
        </div>
      ) : (
        <Form
          id={id}
          onSubmit={(event) => onSubmit(event)}
        >
          {children}
        </Form>
      )}
    </div>
  </div>
)

DeviseLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ]).isRequired,
  id: PropTypes.string,
  onSubmit: PropTypes.func,
  title: PropTypes.string.isRequired
}

export default DeviseLayout
